import {reqPost, reqUpload} from "@/utils/request";

// 授权
export const adminAuthLogin = param => reqPost('/admin/auth/login', param);

// 用户信息
export const adminAccountDetail = param => reqPost('/admin/account/detail', param);
export const adminAccountLogout = param => reqPost('/admin/account/logout', param);

// 个人中心
export const adminProfileInfo = param => reqPost('/admin/profile/info', param);
export const adminProfilePasswordUpdate = param => reqPost('/admin/profile/passwordUpdate', param);

// 卡号管理
export const adminSimListDetail = param => reqPost('/admin/sim/listDetail', param);
export const adminSimList = param => reqPost('/admin/sim/list', param);
export const adminSimDetail = param => reqPost('/admin/sim/detail', param);
export const adminSimCreateDetail = param => reqPost('/admin/sim/createDetail', param);
export const adminSimCreate = param => reqPost('/admin/sim/create', param);
export const adminSimUpdateDetail = param => reqPost('/admin/sim/updateDetail', param);
export const adminSimUpdate = param => reqPost('/admin/sim/update', param);
export const adminSimUpdateStatusDetail = param => reqPost('/admin/sim/updateStatusDetail', param);
export const adminSimUpdateStatus = param => reqPost('/admin/sim/updateStatus', param);
export const adminSimDelete = param => reqPost('/admin/sim/delete', param);

// 套餐管理
export const adminSchemeTypeList = param => reqPost('/admin/scheme/typeList', param);
export const adminSchemeList = param => reqPost('/admin/scheme/list', param);
export const adminSchemeCreateDetail = param => reqPost('/admin/scheme/createDetail', param);
export const adminSchemeCreate = param => reqPost('/admin/scheme/create', param);
export const adminSchemeUpdateDetail = param => reqPost('/admin/scheme/updateDetail', param);
export const adminSchemeUpdate = param => reqPost('/admin/scheme/update', param);
export const adminSchemeDelete = param => reqPost('/admin/scheme/delete', param);

// 订单管理
export const adminRechargeTypeList = param => reqPost('/admin/recharge/typeList', param);
export const adminRechargeList = param => reqPost('/admin/recharge/list', param);
export const adminRechargeDetail = param => reqPost('/admin/recharge/detail', param);
export const adminRechargeClose = param => reqPost('/admin/recharge/close', param);

// 开票管理
export const adminInvoiceList = param => reqPost('/admin/invoice/list', param);
export const adminInvoiceUpdateDetail = param => reqPost('/admin/invoice/updateDetail', param);
export const adminInvoiceUpdate = param => reqUpload('/admin/invoice/update', param);
export const adminInvoiceDelete = param => reqPost('/admin/invoice/delete', param);

// 客户管理
export const adminCustomList = param => reqPost('/admin/custom/list', param);

// 账号管理
export const adminPeopleList = param => reqPost('/admin/people/list', param);
export const adminPeopleCreateDetail = param => reqPost('/admin/people/createDetail', param);
export const adminPeopleCreate = param => reqPost('/admin/people/create', param);
export const adminPeopleUpdateDetail = param => reqPost('/admin/people/updateDetail', param);
export const adminPeopleUpdate = param => reqPost('/admin/people/update', param);
export const adminPeopleDelete = param => reqPost('/admin/people/delete', param);

// 客服管理
export const adminContactList = param => reqPost('/admin/contact/list', param);

// 版本记录
export const adminVersionList = param => reqPost('/admin/version/list', param);

